<template>
  <auth-layout pageClass="register-page">
    <div class="row d-flex justify-content-center">
      <div class="col-md-8">
        <div class="header-text">
          <h2>Hilo Aviation Registration Page</h2>
          <h4>Register today to gain access!</h4>
          <hr />
        </div>
      </div>
      <div class="col-md-5 ml-auto">
        <fade-render-transition :duration="200">
          <div class="media">
            <div class="media-left">
              <div class="icon">
                <i class="nc-icon nc-circle-09"></i>
              </div>
            </div>
            <div class="media-body">
              <h4>Connect Today</h4>
              <p>
                Enter your information to register your account and gain access
                to our system!
              </p>
            </div>
          </div>
        </fade-render-transition>
        <fade-render-transition :delay="200" :duration="200">
          <div class="media">
            <div class="media-left">
              <div class="icon">
                <i class="nc-icon nc-preferences-circle-rotate"></i>
              </div>
            </div>
            <div class="media-body">
              <h4>Awesome Performances</h4>
              <p>Join our mission in using AI to improve aviation training!</p>
            </div>
          </div>
        </fade-render-transition>
        <fade-render-transition :delay="400" :duration="200">
          <div class="media">
            <div class="media-left">
              <div class="icon">
                <i class="nc-icon nc-planet"></i>
              </div>
            </div>
            <div class="media-body">
              <h4>Support</h4>
              <p>
                Having trouble signing in? Give us a call and we'll help you get
                started!
              </p>
            </div>
          </div>
        </fade-render-transition>
      </div>
      <div class="col-md-4 mr-auto">
        <form method="#" action="#">
          <card class="card-plain">
            <div>
              <fg-input
                v-model="newUser.username"
                placeholder="Your Username"
              ></fg-input>
              <fg-input
                v-model="newUser.email"
                placeholder="Your Email"
              ></fg-input>
              <fg-input
                v-model="newUser.password"
                placeholder="Your Password"
                type="password"
              ></fg-input>
              <fg-input
                v-model="newUser.firstName"
                placeholder="Your First Name"
              ></fg-input>
              <fg-input
                v-model="newUser.lastName"
                placeholder="Your Last Name"
              ></fg-input>
              <fg-input
                v-model="newUser.phone"
                placeholder="Your Phone Number"
              ></fg-input>
              <fg-input
                v-model="newUser.address"
                placeholder="Your Address"
              ></fg-input>
            </div>
            <div class="text-center">
              <button
                @click="registerUser"
                type="button"
                class="btn btn-fill btn-default btn-neutral btn-wd"
              >
                Create Free Account
              </button>
            </div>
            <div class="text-center">
              <div class="txt">Check your email for account verification</div>
            </div>
          </card>
        </form>
      </div>
    </div>
    <el-dialog center title="Success" :visible.sync="modals.success">
      <div class="text-center">
        <span>Success: {{ success_txt }}</span>
        <div class="text-center mt-4">
          <span slot="footer">
            <l-button
              round
              class="btn btn-success mt-4"
              @click="closeModal('success')"
              >OK</l-button
            >&nbsp;
          </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog center title="Error" :visible.sync="modals.error">
      <div class="text-center">
        <span>Error: {{ error_txt }}</span>
        <div class="text-center mt-4">
          <span slot="footer" class="dialog-footer">
            <l-button type="btn btn-danger" round @click="closeModal('error')"
              >OK</l-button
            >&nbsp;
          </span>
        </div>
      </div>
    </el-dialog>
  </auth-layout>
</template>
<script>
import UsersAPIService from "../../../servicehandlers/UsersAPIService";
const usersAPIService = new UsersAPIService();
import CommonAPIService from "../../../servicehandlers/CommonHandler";
const apiService = new CommonAPIService();
import { Message, Button, Dialog, Switch } from "element-ui";
import { FadeRenderTransition } from "src/components/index";
import AuthLayout from "./AuthLayout.vue";

export default {
  components: {
    [Message.name]: Message,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Switch.name]: Switch,
    FadeRenderTransition,
    AuthLayout,
  },
  data() {
    return {
      newUser: {
        username: "",
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        phone: "",
        address: "",
      },
      spinning: false,
      passwordError: "",
      success_txt: "",
      error_txt: "",
      modals: {
        success: false,
        error: false,
      },
    };
  },
  methods: {
    registerUser() {
      if (!this.newUser.username) {
        Message.error("No username entered!");
        return;
      }
      if (!this.newUser.email) {
        Message.error("No email entered!");
        return;
      }
      if (!this.newUser.password) {
        Message.error("No password entered!");
        return;
      }
      if (!this.newUser.firstName) {
        Message.error("No first name entered!");
        return;
      }
      if (!this.newUser.lastName) {
        Message.error("No last name entered!");
        return;
      }
      if (!this.newUser.phone) {
        Message.error("No phone number entered!");
        return;
      }
      if (!this.newUser.address) {
        Message.error("No address entered!");
        return;
      }
      this.spinning = true;
      return usersAPIService.checkUsername(this.username).then((response) => {
        if (parseInt(response) === 1) {
          // username taken
          this.error_txt = "Username is already taken";
          this.openModal("error");
          this.spinning = false;
        } else {
          const user = {
            username: this.username,
            email: this.email,
            password: this.password,
            firstName: this.firstName,
            lastName: this.lastName,
            phone: this.phone,
            address: this.address,
            validated: 0,
          };
          return usersAPIService
            .registerUser(1, this.newUser, this.$router)
            .then((newUser) => {
              this.spinning = false;
              Message.success(
                "Successfully created account! Check email for verification",
              );
              this.newUser.username = "";
              this.newUser.email = "";
              this.newUser.password = "";
              this.newUser.firstName = "";
              this.newUser.lastName = "";
              this.newUser.phone = "";
              this.newUser.address = "";
              this.spinning = false;
            })
            .catch((error) => {
              this.spinning = false;
              this.error_txt = "Error registering user: " + error;
              this.openModal("error");
            });
        }
      });
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    openModal(name) {
      this.modals[name] = true;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
  },
  beforeDestroy() {
    this.closeMenu();
  },
};
</script>
<style scoped>
.txt {
  color: darkgrey;
  font-size: 15px;
  margin-top: 10px;
}
</style>
